(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-and-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.WatchBuyProSlider) return;

  function WatchBuyProSlider(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-wbp-viewport]');
    this.track = root.querySelector('[data-wbp-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-wbp-slide]'));
    this.prevBtn = root.querySelector('[data-wbp-prev]');
    this.nextBtn = root.querySelector('[data-wbp-next]');
    this.dotsWrap = root.querySelector('[data-wbp-dots]');

    if (!this.viewport || !this.track || this.slides.length === 0) return;

    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 4000;
    this.infinite = root.dataset.infinite === 'true';
    this.pauseOnHover = root.dataset.pauseOnHover === 'true';
    this.enableDrag = root.dataset.enableDrag === 'true';

    this.currentIndex = 0;
    this.slideWidth = 0;
    this.gap = 0;
    this.isDragging = false;
    this.dragStartX = 0;
    this.dragCurrentX = 0;
    this.dragBaseOffset = 0;
    this.autoplayTimer = null;
    this.videoObserver = null;

    this.onResize = this.onResize.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.onDragMove = this.onDragMove.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onWheel = this.onWheel.bind(this);

    this.setup();
  }

  WatchBuyProSlider.prototype.setup = function () {
    this.measure();
    this.buildDots();
    this.bindEvents();
    this.observeVideos();
    this.updatePosition(false);
    this.updateArrows();
    if (this.autoplay) this.startAutoplay();
  };

  WatchBuyProSlider.prototype.measure = function () {
    var firstSlide = this.slides[0];
    var rect = firstSlide.getBoundingClientRect();
    var styles = getComputedStyle(this.track);
    this.gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    this.slideWidth = rect.width + this.gap;
  };

  WatchBuyProSlider.prototype.buildDots = function () {
    if (!this.dotsWrap) return;
    this.dotsWrap.innerHTML = '';
    var self = this;
    this.slides.forEach(function (slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'wbp-dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dot.addEventListener('click', function () {
        self.goTo(index);
        self.restartAutoplay();
      });
      self.dotsWrap.appendChild(dot);
    });
    this.dots = Array.prototype.slice.call(this.dotsWrap.querySelectorAll('.wbp-dot'));
    this.updateDots();
  };

  WatchBuyProSlider.prototype.updateDots = function () {
    if (!this.dots) return;
    this.dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', false);
    });
    var idx = this.currentIndex % this.slides.length;
    if (idx < 0) idx += this.slides.length;
    if (this.dots[idx]) this.dots[idx].classList.add('is-active');
  };

  WatchBuyProSlider.prototype.bindEvents = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.prev();
        self.restartAutoplay();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.next();
        self.restartAutoplay();
      });
    }

    window.addEventListener('resize', this.onResize);

    this.viewport.addEventListener('keydown', this.onKeyDown);
    this.viewport.addEventListener('wheel', this.onWheel, { passive: false });

    if (this.enableDrag) {
      this.viewport.addEventListener('mousedown', this.onDragStart);
      this.viewport.addEventListener('touchstart', this.onDragStart, { passive: true });
      window.addEventListener('mousemove', this.onDragMove);
      window.addEventListener('touchmove', this.onDragMove, { passive: false });
      window.addEventListener('mouseup', this.onDragEnd);
      window.addEventListener('touchend', this.onDragEnd);
    }

    if (this.pauseOnHover) {
      this.root.addEventListener('mouseenter', function () {
        self.stopAutoplay();
      });
      this.root.addEventListener('mouseleave', function () {
        if (self.autoplay) self.startAutoplay();
      });
    }
  };

  WatchBuyProSlider.prototype.onResize = function () {
    this.measure();
    this.updatePosition(false);
  };

  WatchBuyProSlider.prototype.onKeyDown = function (event) {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.next();
      this.restartAutoplay();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.prev();
      this.restartAutoplay();
    }
  };

  WatchBuyProSlider.prototype.onWheel = function (event) {
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
    event.preventDefault();
    if (event.deltaX > 10) {
      this.next();
      this.restartAutoplay();
    } else if (event.deltaX < -10) {
      this.prev();
      this.restartAutoplay();
    }
  };

  WatchBuyProSlider.prototype.getPointerX = function (event) {
    if (event.touches && event.touches.length) return event.touches[0].clientX;
    if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0].clientX;
    return event.clientX;
  };

  WatchBuyProSlider.prototype.onDragStart = function (event) {
    this.isDragging = true;
    this.dragStartX = this.getPointerX(event);
    this.dragBaseOffset = this.currentOffset || 0;
    this.track.style.transition = 'none';
    this.stopAutoplay();
  };

  WatchBuyProSlider.prototype.onDragMove = function (event) {
    if (!this.isDragging) return;
    if (event.cancelable) event.preventDefault();
    this.dragCurrentX = this.getPointerX(event);
    var delta = this.dragCurrentX - this.dragStartX;
    this.setTrackOffset(this.dragBaseOffset + delta);
  };

  WatchBuyProSlider.prototype.onDragEnd = function () {
    if (!this.isDragging) return;
    this.isDragging = false;
    var delta = (this.dragCurrentX || this.dragStartX) - this.dragStartX;
    this.track.style.transition = '';
    if (Math.abs(delta) > this.slideWidth * 0.15) {
      if (delta < 0) this.next();
      else this.prev();
    } else {
      this.updatePosition(true);
    }
    if (this.autoplay) this.startAutoplay();
  };

  WatchBuyProSlider.prototype.setTrackOffset = function (offset) {
    this.currentOffset = offset;
    this.track.style.transform = 'translateX(' + offset + 'px)';
  };

  WatchBuyProSlider.prototype.updatePosition = function (animate) {
    this.track.style.transition = animate ? 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
    var offset = -(this.currentIndex * this.slideWidth);
    this.setTrackOffset(offset);
    this.updateDots();
  };

  WatchBuyProSlider.prototype.next = function () {
    var maxIndex = this.slides.length - 1;
    if (this.currentIndex >= maxIndex) {
      if (this.infinite) {
        this.currentIndex = 0;
      } else {
        return;
      }
    } else {
      this.currentIndex += 1;
    }
    this.updatePosition(true);
    this.updateArrows();
  };

  WatchBuyProSlider.prototype.prev = function () {
    if (this.currentIndex <= 0) {
      if (this.infinite) {
        this.currentIndex = this.slides.length - 1;
      } else {
        return;
      }
    } else {
      this.currentIndex -= 1;
    }
    this.updatePosition(true);
    this.updateArrows();
  };

  WatchBuyProSlider.prototype.goTo = function (index) {
    this.currentIndex = index;
    this.updatePosition(true);
    this.updateArrows();
  };

  WatchBuyProSlider.prototype.updateArrows = function () {
    if (this.infinite) return;
    if (this.prevBtn) this.prevBtn.disabled = this.currentIndex <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.slides.length - 1;
  };

  WatchBuyProSlider.prototype.startAutoplay = function () {
    var self = this;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(function () {
      self.next();
    }, this.autoplaySpeed);
  };

  WatchBuyProSlider.prototype.stopAutoplay = function () {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  };

  WatchBuyProSlider.prototype.restartAutoplay = function () {
    if (this.autoplay) this.startAutoplay();
  };

  WatchBuyProSlider.prototype.observeVideos = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      this.slides.forEach(function (slide) {
        var video = slide.querySelector('video');
        if (video) video.play().catch(function () {});
      });
      return;
    }

    this.videoObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { root: this.viewport, threshold: 0.55 }
    );

    this.slides.forEach(function (slide) {
      self.videoObserver.observe(slide);
    });

    this.slides.forEach(function (slide) {
      var muteBtn = slide.querySelector('[data-wbp-mute]');
      var video = slide.querySelector('video');
      if (muteBtn && video) {
        muteBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          video.muted = !video.muted;
          muteBtn.classList.toggle('is-unmuted', !video.muted);
        });
      }
    });
  };

  window.WatchBuyProSlider = WatchBuyProSlider;
})();

  } catch(e) { console.error(e); }
})();
})();
